'use client';

import { cx } from 'class-variance-authority';
import type { MouseEvent } from 'react';
import { scrollToAnchor } from './helpers/scrollToAnchor';
import { useActiveAnchor } from './hooks/useActiveAnchor';
import styles from './faqPageSidebar.module.scss';
import type { FaqPageSidebarProps } from './types';

const handleAnchorClick = (
  event: MouseEvent<HTMLAnchorElement>,
  anchorId: string
) => {
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  scrollToAnchor(anchorId);
};

const FaqPageSidebar = ({ groups }: Readonly<FaqPageSidebarProps>) => {
  const activeAnchor = useActiveAnchor(groups);

  if (groups.length === 0) return null;

  return (
    <nav className={styles.sidebar} aria-label="FAQ sections">
      <ul className={styles.list}>
        {groups.map((group) => {
          const isActive = group.anchorId === activeAnchor;
          return (
            <li key={group.anchorId} className={styles.listItem}>
              <a
                href={`#${group.anchorId}`}
                className={cx(styles.link, isActive && styles.linkActive)}
                aria-current={isActive ? 'true' : undefined}
                onClick={(event) => handleAnchorClick(event, group.anchorId)}
              >
                {group.header}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default FaqPageSidebar;
